import React from "react";
import { OverlayBadge } from "./OverlayBadge";
import { useEditPanelState } from "../../graphql/hooks";

export const JobDuplicateCheckOverlayBadge = () => {
    const { jobDuplicateCheck } = useEditPanelState();

    if (!jobDuplicateCheck) {
        return null;
    }

    return (
        <OverlayBadge
            badgeHeader="Duplicate Job Error!"
            badgeVariant="danger"
            overlayText="current config creates duplicate jobs"
            className="mt-2 p-1 me-2"
        />
    );
};
